@if (actionsComponents(); as components) {
  <div class="flex h-full w-full items-stretch gap-2">
    <pt-dynamic-component
      *ngFor="let component of components; trackBy: trackByDefinition"
      class="h-full"
      [definition]="component"
    />
  </div>
}
